/**
 * Whether a plan change should apply immediately.
 * Fewer slots is always period-end. Otherwise cheaper amount is period-end. Year → month is always period-end.
 *
 * @param {string} currentInterval Current Stripe interval
 * @param {number} currentLevel Current slot count or sub_level
 * @param {string} nextInterval Target Stripe interval
 * @param {number} nextLevel Target slot count or sub_level
 * @param {number} [currentAmountCents=0] Current recurring amount in cents
 * @param {number} [nextAmountCents=0] Target recurring amount in cents
 * @returns {boolean} True when the change should bill immediately
 */
export function isImmediatePlanChange(
  currentInterval: string,
  currentLevel: number,
  nextInterval: string,
  nextLevel: number,
  currentAmountCents = 0,
  nextAmountCents = 0,
): boolean {
  if (nextLevel < currentLevel) return false;
  if (currentInterval === 'year' && nextInterval === 'month') return false;
  if (currentAmountCents > 0 && nextAmountCents > 0) {
    return nextAmountCents > currentAmountCents;
  }
  if (currentInterval === 'month') {
    return nextInterval === 'year' || nextLevel > currentLevel;
  }
  if (currentInterval === 'year') {
    return nextLevel > currentLevel && nextInterval === 'year';
  }
  return false;
}
